import React from 'react';

import { FinancialDetailsFilter } from '../../helper';
import { ModalOKCancel } from '../../modals';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Button from '@material-ui/core/Button';

import FormLabel from '@material-ui/core/FormLabel';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { FileUpload } from 'primereact/fileupload';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';


import { Typeahead } from 'react-bootstrap-typeahead';

import { toast } from 'react-toastify';
import api from '../../ApiService';

export default class Financials extends React.Component {
    constructor(props) {
        super(props);

        this.ivet360LineItemEditor = this.ivet360LineItemEditor.bind(this);
        this.ivet360LineItemTemplate = this.ivet360LineItemTemplate.bind(this);
        this.sortFunction = this.sortFunction.bind(this);
        this.onivet360LineItemChange = this.onivet360LineItemChange.bind(this);
        this.onActiveChange = this.onActiveChange.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.onBeforeSend = this.onBeforeSend.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.onError = this.onError.bind(this);

        this.onivet360LineItemChange = this.onivet360LineItemChange.bind(this);
        this.onivet360LineItemInputChange = this.onivet360LineItemInputChange.bind(this);
        this.onivet360LineItemBlur = this.onivet360LineItemBlur.bind(this);

        this.state = {
            loadingIncomeValidation: true,
            loadingMappings: true,
            reloadingMappings: false,
            incomeValidation: {},
            mappings: [],
            ivet360LineItems: [],
            filter: FinancialDetailsFilter.Active,
            isDirty: false,
            pauseivet360LineItemSort: false, // needed to prevent sorting while editing
            confirmationText: '',
            showModal: false
        };
    }

    componentDidMount = async () => {
        this.props.alertFinancialsComponentOfHospitalChange(this.alertFinancialsComponentOfHospitalChange);

        // Load Income Validation table
        let incomeValidation = await api.getIncomeValidation(this.props.selectedHospital.nameHash);
        if (incomeValidation) {
            // go ahead a let it render the table
            this.setState({ loadingIncomeValidation: false, incomeValidation });
        }

        // Load Mappings
        let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, this.state.filter);
        // Load Line Items
        let ivet360LineItems = await api.getIVet360LineItems();

        if (mappings && ivet360LineItems) {
            this.setState({ loadingMappings: false, mappings, ivet360LineItems });
        }
    }

    alertFinancialsComponentOfHospitalChange = async (hospital) => {
        this.setState({ loadingIncomeValidation: true, loadingMappings: true });

        let incomeValidation = await api.getIncomeValidation(hospital.nameHash);
        if (incomeValidation) {
            this.setState({ incomeValidation, loadingIncomeValidation: false });
        }

        // Load Mappings
        let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, this.state.filter);
        if (mappings) {
            this.setState({ loadingMappings: false, mappings });
        }
    }

    getMonthHeader = (monthsBack) => {
        // could be from 1-6 (-5) to 12-1 (11)
        let now = new Date();
        let utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
        let target = utc.getMonth() + 1 - monthsBack;
        switch (target) {
            case 1:
                return 'January';
            case 2:
                return 'February';
            case 3:
                return 'March';
            case 4:
                return 'April';
            case 5:
                return 'May';
            case 6:
                return 'June';
            case 7: case -5:
                return 'July';
            case 8: case -4:
                return 'August';
            case 9: case -3:
                return 'September';
            case 10: case -2:
                return 'October';
            case 11: case -1:
                return 'November';
            case 0:
                return 'December';
            default:
                return 'ERROR';
        }
    }

    formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }

    //------------------
    // Mappings handlers
    //------------------
    handleFilterChange = async (e) => {
        e.preventDefault(); // ?
        let filter = e.target.value;

        // PrimeReact has a timing issue when removing rows - it throws an uncaught error in BodyCell.js
        // By clearing the mappings array here we can avoid that error
        this.setState({ filter, reloadingMappings:true, mappings: [] }); 

        // Load Mappings
        let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, filter);
        if (mappings) {
            this.setState({ mappings, reloadingMappings: false, isDirty: false });
        }
    }

    onivet360LineItemChange = (props, selections) => {
        if (selections === undefined || selections.length === null || selections.length === 0) return;

        if (this.state.pauseivet360LineItemSort === false) {
            this.setState({ pauseivet360LineItemSort: true });
        }

        let updatedItems = [...props.value];
        updatedItems[props.rowIndex].iVet360LineItemId = selections[0].id;
        updatedItems[props.rowIndex].edited = true;
        this.setState({ mappings: updatedItems, isDirty: true });
    }
    onivet360LineItemBlur = () => {
        // must check first or we get in a loop of set states (not sure why)
        if (this.state.pauseivet360LineItemSort === true) {
            this.setState({ pauseivet360LineItemSort: false });
        }
    }
    onivet360LineItemInputChange = (props, e) => {
        if (e.keyCode === 13) {
            // The Enter will also exit the cell/editing so we don't need to turn off the sort - although it will move the item immediately

            let updatedItems = [...props.value];
            let ivet360LineItemId = this.state.ivet360LineItems.find(x => x.name === e.target.value).id;
            updatedItems[props.rowIndex].iVet360LineItemId = ivet360LineItemId;
            updatedItems[props.rowIndex].edited = true;
            this.setState({ mappings: updatedItems, isDirty: true });            
        }
    }

    // http://ericgio.github.io/react-bootstrap-typeahead/
    // https://stackoverflow.com/questions/47487326/react-bootstrap-typeahead-allownew-select-on-blur
    ivet360LineItemEditor = (props) => {
        let itemId = props.value[props.rowIndex].iVet360LineItemId;
        let item = this.state.ivet360LineItems.find(x => x.id === itemId);

        // Note - the selectHintOnEnter prop doesn't work so using 'manual' onKeyDown handler

        return (
            <Typeahead labelKey='name' options={this.state.ivet360LineItems} placeholder={item ? item.name : ''} 
                onChange={(selections) => this.onivet360LineItemChange(props, selections)}
                onBlur={this.onivet360LineItemBlur}
                onKeyDown={(e) => this.onivet360LineItemInputChange(props, e)}
            />);
    }

    ivet360LineItemTemplate = (rowData, column) => {
        let ivet360LineItem = this.state.ivet360LineItems.find(x => x.id === rowData.iVet360LineItemId);
        if (ivet360LineItem) {
            return <span>{ivet360LineItem.name}</span>;
        }
        else {
            return <span />;
        }
    }

    onActiveChange = (e, rowData) => {
        e.preventDefault();
        let itemIdx = this.state.mappings.findIndex(x => x.id === rowData.id);
        let updatedItems = [...this.state.mappings];
        updatedItems[itemIdx].active = !rowData.active;
        updatedItems[itemIdx].edited = true;
        this.setState({ mappings: updatedItems, isDirty: true });
    }

    activeTemplate = (rowData) => {
        return (
            <Checkbox checked={rowData.active} onChange={(e) => this.onActiveChange(e, rowData)} />
        );
    }

    currencyTemplate = (rowData, column) => {
        return <div style={{ textAlign: 'right' }}>{this.formatCurrency(rowData[column.field])}</div>;
    }

    compareFunction = (a, b) => {
        let v1 = this.state.ivet360LineItems.find(x => x.id === a.iVet360LineItemId);
        if (v1 === undefined || v1 === null) v1 = '';
        else v1 = v1.name;

        let v2 = this.state.ivet360LineItems.find(x => x.id === b.iVet360LineItemId);
        if (v2 === undefined || v2 === null) v2 = '';
        else v2 = v2.name;

        if (v1 < v2) return -1;
        if (v2 < v1) return 1;
        return 0;
    }

    sortFunction = (e) => {
        if (this.state.pauseivet360LineItemSort) 
            return this.state.mappings; // leave it be!
        else if (e.order === 1) 
            return this.state.mappings.sort(this.compareFunction);        
        else 
            return this.state.mappings.sort(this.compareFunction).reverse();        
    }

    onClickCancel = async (e) => {
        e.preventDefault();

        // reload mappings from server
        let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, this.state.filter);
        if (mappings) {
            this.setState({ mappings, isDirty: false });
            toast.success("Changes canceled.");
        }
    }

    onClickSave = async (e) => {
        e.preventDefault();

        let changedItems = this.state.mappings.filter(x => x.edited === true);
        let result = await api.saveFinancialMappings(changedItems);
        if (result) {
            // we also need to update the summary table
            let incomeValidation = await api.getIncomeValidation(this.props.selectedHospital.nameHash);
            let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, this.state.filter);

            if (mappings && incomeValidation) {
                this.setState({ mappings, incomeValidation, isDirty: false });
                toast.success("Mappings updated.");
            }
        }
    }

    // ----------------
    // Clear Financials
    // ----------------

    onClickClearData = async (e) => {
        e.preventDefault();
        let msg = `Clear data for hospital ${this.props.selectedHospital.name}?`;
        this.setState({ confirmationText: msg, showModal: true });

    }
    onClickClearAll = async (e) => {
        e.preventDefault();
        let msg = `Clear data and mappings for hospital ${this.props.selectedHospital.name}?`;
        this.setState({ confirmationText: msg, showModal: true });
    }

    onModalOK = async (e) => {
        this.setState({ showModal: false });

        if (this.state.confirmationText.includes('mappings')) {
            var err = await api.clearFinancialDataAndMappings(this.props.selectedHospital.nameHash);
            if (!err) {
                var successMsg = 'Data and mappings cleared.';
            }
        }
        else {
            await api.clearFinancialData(this.props.selectedHospital.nameHash);
            if (!err) {
                successMsg = 'Data cleared.';
            }
        }

        if (err) {
            toast.error(err);
        }
        else {
            // we also need to update the summary table
            let incomeValidation = await api.getIncomeValidation(this.props.selectedHospital.nameHash);
            let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, this.state.filter);

            if (mappings && incomeValidation) {
                this.setState({ mappings, incomeValidation });
            }

            toast.success(successMsg);
        }
    }

    onModalCancel = async (e) => {
        this.setState({ showModal: false });
    }

    //---------------------
    // File upload handlers
    //---------------------
    onBeforeSend = (e) => {
        e.xhr.setRequestHeader('authorization', `Bearer ${localStorage.getItem('token')}`);
        toast.warn("Uploading file...", { autoClose: false, position: 'bottom-right' });
    }

    onUpload = async (e) => {
        toast.dismiss();
        toast.success('Upload successful.');

        // Reload with filter set to Active
        this.setState({ filter: FinancialDetailsFilter.Active, loadingMappings: true, mappings: [] }); 

        // we also need to update the summary table
        let incomeValidation = await api.getIncomeValidation(this.props.selectedHospital.nameHash);
        let mappings = await api.getFinancialMappings(this.props.selectedHospital.nameHash, FinancialDetailsFilter.Active);
        if (mappings && incomeValidation) {
            this.setState({ mappings, incomeValidation, filter: FinancialDetailsFilter.Active, loadingMappings: false, isDirty: false });
        }
    }

    onError = (e) => {
        toast.error('Trouble uploading file.', { autoClose: 5000 });
    }

    //-----------------
    // Render functions
    //-----------------
    renderIncomeValidationTable() {
        return (
            <Table xs={10}>
                <TableHead>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" />
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>{this.getMonthHeader(5)}</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>{this.getMonthHeader(4)}</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>{this.getMonthHeader(3)}</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>{this.getMonthHeader(2)}</TableCell>
                        <TableCell component="th" style={{ textAlign: 'right', fontWeight: '500', fontSize: 'unset', color: 'black' }}>{this.getMonthHeader(1)}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Calculated Net Income</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.calculatedNetIncomeFiveMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.calculatedNetIncomeFourMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.calculatedNetIncomeThreeMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.calculatedNetIncomeTwoMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.calculatedNetIncomeOneMonthAgo)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Practice Net Income</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.practiceNetIncomeFiveMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.practiceNetIncomeFourMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.practiceNetIncomeThreeMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.practiceNetIncomeTwoMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.practiceNetIncomeOneMonthAgo)}</TableCell>
                    </TableRow>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>Variance</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.varianceFiveMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.varianceFourMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.varianceThreeMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.varianceTwoMonthsAgo)}</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{this.formatCurrency(this.state.incomeValidation.varianceOneMonthAgo)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    renderDropzone() {
        let url = `api/financials?nameHash=${this.props.selectedHospital.nameHash}`;
        let label = 'Upload CSV';
        if (this.state.isDirty === true) label += ' (disabled due to pending edits)';
        return (
            <div>
                <FormLabel component='span'>{label}</FormLabel>
                <FileUpload name='csvFile' url={url} auto accept=".csv,.CSV" chooseLabel="CHOOSE" style={{ backgroundColor: 'gray' }}
                    onBeforeSend={this.onBeforeSend} onUpload={this.onUpload} onError={this.onError} disabled={this.state.isDirty}
                />
            </div>
        );
    }

    renderSaveCancel(columnSpread) {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', minWidth: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={this.onClickSave} style={{ minWidth: '80px' }} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderFilterAndSaveCancel() {
        return (
            <Grid container spacing={24}>
                <Grid item xs={3}>
                    <FormControl fullWidth disabled={this.state.isDirty} >
                        <InputLabel htmlFor="filter" style={{ fontWeight: 'normal' }}>Filter</InputLabel>
                        <Select
                            value={this.state.filter}
                            onChange={this.handleFilterChange}
                            inputProps={{ name: 'filter', id: 'filter' }}
                        >
                            <MenuItem key={FinancialDetailsFilter.Undetermined} value={FinancialDetailsFilter.Undetermined}>{FinancialDetailsFilter.Undetermined}</MenuItem>
                            <MenuItem key={FinancialDetailsFilter.Active} value={FinancialDetailsFilter.Active}>{FinancialDetailsFilter.Active}</MenuItem>
                            <MenuItem key={FinancialDetailsFilter.Inactive} value={FinancialDetailsFilter.Inactive}>{FinancialDetailsFilter.Inactive}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={1} style={{ display: 'flex', alignItems: 'flex-end' }} >
                    {this.state.reloadingMappings &&
                        <em>Filtering...</em>}
                </Grid>
                <Grid item xs={4} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                    <Button variant='contained' color='default' style={{ marginRight: '15px', minWidth: '130px' }} onClick={this.onClickClearData} disabled={this.state.isDirty}>Clear Values</Button>
                    <Button variant='contained' color='default' onClick={this.onClickClearAll} style={{ minWidth: '130px' }} disabled={this.state.isDirty}>Clear All</Button>
                </Grid>
                {this.renderSaveCancel(4)}
            </Grid>
        );
    }

    renderDetailsTable() {
        // Note!: If you add resizeablecolumns then the dropdown expands only in the active cell - effectively hiding it

        return (
            <div>
                <DataTable value={this.state.mappings}  editable>
                    <Column field="iVet360LineItemId" header="iVet Line Item" style={{width: '25%'}}
                        sortable="custom" sortFunction={this.sortFunction}
                        editor={this.ivet360LineItemEditor} body={this.ivet360LineItemTemplate}
                    />
                    <Column field="hospitalLineItemName" header="Hospital Line Item" sortable="true" style={{ width: '17%' }} />
                    <Column field="fiveMonthsBack"       header={this.getMonthHeader(5)} sortable="true" style={{ width: '10%' }}  body={this.currencyTemplate} />
                    <Column field="fourMonthsBack"       header={this.getMonthHeader(4)} sortable="true" style={{ width: '10%' }}  body={this.currencyTemplate}/>
                    <Column field="threeMonthsBack"      header={this.getMonthHeader(3)} sortable="true" style={{ width: '10%' }}  body={this.currencyTemplate}/>
                    <Column field="twoMonthsBack"        header={this.getMonthHeader(2)} sortable="true" style={{ width: '10%' }}  body={this.currencyTemplate}/>
                    <Column field="oneMonthBack" header={this.getMonthHeader(1)} sortable="true" style={{ width: '10%' }} body={this.currencyTemplate} />
                    <Column field="active" header="Active" sortable="true" style={{ width: '8%', textAlign: 'center' }} body={this.activeTemplate} />
                </DataTable>
                <br />
                {this.renderSaveCancel(12)}
            </div>
        );
    }

    render() {
        let incomeValidationTable = this.state.loadingIncomeValidation ? <em>Loading...</em> : this.renderIncomeValidationTable();
        let dropzone = this.renderDropzone();
        let filterAndSaveCancel = this.renderFilterAndSaveCancel();
        let mappingDetails = this.state.loadingMappings ? <em>Loading...</em> : this.renderDetailsTable();

        return (
            <div>
                <br />
                {incomeValidationTable}
                <hr />
                {dropzone}
                <hr />
                {filterAndSaveCancel}
                <br />
                {mappingDetails}
                <br />
                <br />

                <ModalOKCancel
                    title="Clear Financials"
                    body={`${this.state.confirmationText}`}
                    show={this.state.showModal}
                    onOK={this.onModalOK.bind(this)}
                    onCancel={this.onModalCancel.bind(this)}
                />

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Hospitals/Financials.js